import DResultsTraits from './DResultsTraits'

export default DResultsTraits
